import Add from '../../visuals/Icons/Old/Add';
import React from 'react';

interface IAddButtonWithLabelProps {
  handleClick?: React.MouseEventHandler<HTMLButtonElement>;
  children: React.ReactNode;
  dataTestId?: string;
}

/**
 * @deprecated Use css utils .tw-lf-button-icon instead
 */
const AddButtonWithLabel: React.FC<IAddButtonWithLabelProps> = ({
  handleClick,
  children,
  dataTestId,
}) => {
  return (
    <>
      <button
        className="add-button-with-label tw-group tw-lf-button-clear tw-flex tw-items-center"
        type="button"
        onClick={handleClick}
        data-testid={dataTestId}
      >
        <span
          className={`
        tw-bg-yellow-600
        tw-text-black-1000
        tw-mr-3 tw-p-0
        tw-text-center
        group-hover:tw-bg-yellow-400
        tw-w-[32px] tw-h-[32px]
        tw-rounded-full
        tw-outline tw-outline-yellow-600
        tw-transition-all tw-duration-200 tw-ease-in
      `}
          aria-hidden="true"
        >
          <Add />
        </span>
        <span className="tw-text-base">{children}</span>
      </button>
      <style jsx>{``}</style>
    </>
  );
};

export default AddButtonWithLabel;
